// src/components/SearchFilter.js
import { useState, useRef, useEffect } from "react";
import filterIcon from "../assets/filter-icon.png";
import { useTranslation } from "react-i18next";
import { req_Status } from "../utils/enums";
import FilterButton from "./FilterButton";

const SearchFilter = ({
  options,
  selected,
  setSelected,
  thick,
  flex,
  errorText,
  onChange,
  page = "invoices",
  getData = null,
  nameInAr = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const isFirstClick = useRef(true);
  const { t } = useTranslation("general");
  const [loading, setLoading] = useState({ status: req_Status.NULL });

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  const toggleDropdown = async () => {
    setIsOpen(!isOpen);

    if (getData && isFirstClick.current) {
      setLoading((prev) => ({ ...prev, status: req_Status.PENDING }));
      const req = await getData();
      isFirstClick.current = false;

      if (req?.status === 200) {
        setLoading((prev) => ({ ...prev, status: req_Status.SUCCESS }));
      } else {
        setLoading((prev) => ({ ...prev, status: req_Status.FAILED }));
      }
    }
  };

  const handleItemClick = (item) => {
    setSelected(item, page);
    if (onChange) {
      onChange(item);
    }
    setIsOpen(false);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      toggleDropdown();
    }
  };

  const showError = !selected?.value && errorText;

  return (
    <div
      className={`c-search-filter ${flex ? "full-width-dropdown" : ""}`}
      ref={dropdownRef}
      onClick={toggleDropdown}
      onKeyDown={handleKeyDown}
    >
      {showError && <div className="error-message">{t(errorText)}</div>}
      <div
        tabIndex={0} // Make the dropdown toggle focusable
        className={`toggle ${isOpen ? "opened" : ""} ${thick ? "thick" : ""}`}
      >
        {/* {!nameInAr ? (
          options && typeof selected === "object" && selected !== null ? (
            <p className="text">
              {selected?.title ? t(selected.title) : selected?.name}
            </p>
          ) : null
        ) : options && typeof selected === "object" && selected !== null ? (
          <p className="text">
            {selected?.title
              ? t(selected.title)
              : nameInAr
              ? selected?.nameInAr
              : selected?.name}
          </p>
        ) : null} */}

        <FilterButton t={t} isFiltersOpen={isOpen} />
      </div>

      {isOpen && (
        <>
          <ul className="filter-menu">
            {Array.isArray(options) &&
              options.map((option, index) => (
                <li
                  key={index}
                  className="filter-menu-item"
                  onClick={() => handleItemClick(option)}
                  tabIndex={0} // Make each dropdown item focusable
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ") {
                      handleItemClick(option);
                    }
                  }}
                >
                  {!nameInAr
                    ? typeof option === "object"
                      ? t(option?.title) || option?.name
                      : option
                    : typeof option === "object"
                    ? t(option?.title) || option?.nameInAr
                    : option}
                </li>
              ))}
          </ul>
        </>
      )}
    </div>
  );
};

export default SearchFilter;
